import React from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import { useAppSelector } from "src/app-redux/hooks";
import { selectVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";
import ANF from "src/assets/images/terminal_locations/ANF.svg";
import AQD from "src/assets/images/terminal_locations/AQD.svg";
import Army from "src/assets/images/terminal_locations/Army.svg";
import BombDisposal from "src/assets/images/terminal_locations/BombDisposal.svg";
import Commercial from "src/assets/images/terminal_locations/Commercial.svg";
import CustomsInspection from "src/assets/images/terminal_locations/CustomsInspection.svg";
import DetailedInspection from "src/assets/images/terminal_locations/DetailedInspection.svg";
import FC from "src/assets/images/terminal_locations/FC.svg";
import FGS from "src/assets/images/terminal_locations/FGS.svg";
import FiaStation from "src/assets/images/terminal_locations/FiaStation.svg";
import GateEntry from "src/assets/images/terminal_locations/GateEntry.svg";
import GateOut from "src/assets/images/terminal_locations/GateOut.svg";
import NPPD from "src/assets/images/terminal_locations/NPPD.svg";
import Other from "src/assets/images/terminal_locations/Other.svg";
import ParkingYard from "src/assets/images/terminal_locations/ParkingYard.svg";
import Rangers from "src/assets/images/terminal_locations/Rangers.svg";
import ScannerStationGantry from "src/assets/images/terminal_locations/ScannerStationGantry.svg";
import ScannerStationPassthrough from "src/assets/images/terminal_locations/ScannerStationPassthrough.svg";
import SecurityCheckpoint from "src/assets/images/terminal_locations/SecurityCheckpoint.svg";
import Warehouse from "src/assets/images/terminal_locations/Warehouse.svg";
import Weighbridge from "src/assets/images/terminal_locations/Weighbridge.svg";
import NoRecordFound from "src/components/NoRecordFound";
import { useStyles } from "./../style";

export interface IDrawerTrailProps {}

export default function DrawerTrail(props: IDrawerTrailProps) {
  const classes = useStyles();

  // Redux
  const vehicleDetailsResponse: any = useAppSelector(selectVehicleDetails);
  return (
    <Grid container direction="row">
      <Grid
        item
        md={1}
        style={{
          borderBottomLeftRadius: vehicleDetailsResponse.vehicleTrail?.length > 1 ? "15px" : 0,
          borderLeft:
            vehicleDetailsResponse.vehicleTrail?.length > 1 ? "1px solid #D5DCE1" : "none",
          marginLeft: "10px",
          marginTop: "25px",
        }}
      ></Grid>
      <Grid
        item
        md={10}
        id="main-div"
        className={classes.drawerDetails}
        style={{
          marginLeft: "-48px",
          height: "max-content",
        }}
      >
        {/* History Item  */}
        {vehicleDetailsResponse.vehicleTrail?.length !== 0 ? (
          vehicleDetailsResponse.vehicleTrail.map((item: any, index: any) => (
            <>
              <Grid
                key={index}
                container
                spacing={2}
                className={
                  vehicleDetailsResponse.vehicleTrail.length !== 1 &&
                  index == vehicleDetailsResponse.vehicleTrail.length - 1
                    ? "topContainerTrailLastDiv"
                    : "topContainerTrail"
                }
              >
                <Grid container direction="row" className="itemRowTrail">
                  <Grid md={1}>
                    {vehicleDetailsResponse.vehicleTrail.length == 1 ||
                    index != vehicleDetailsResponse.vehicleTrail.length - 1 ? (
                      <img
                        src={
                          item.terminalLocation === "Bomb Disposal"
                            ? BombDisposal
                            : item.terminalLocation === "Commercial"
                            ? Commercial
                            : item.terminalLocation === "Customs Inspection"
                            ? CustomsInspection
                            : item.terminalLocation === "FIA Station"
                            ? FiaStation
                            : item.terminalLocation === "Gate-entry"
                            ? GateEntry
                            : item.terminalLocation === "Gate-out"
                            ? GateOut
                            : item.terminalLocation === "Parking Yard"
                            ? ParkingYard
                            : item.terminalLocation === "Scanner Station (Gantry)"
                            ? ScannerStationGantry
                            : item.terminalLocation === "Scanner Station (Passthrough)"
                            ? ScannerStationPassthrough
                            : item.terminalLocation === "Security Checkpoint"
                            ? SecurityCheckpoint
                            : item.terminalLocation === "Warehouse"
                            ? Warehouse
                            : item.terminalLocation === "Weighbridge"
                            ? Weighbridge
                            : item.terminalLocation === "ANF"
                            ? ANF
                            : item.terminalLocation === "AQD"
                            ? AQD
                            : item.terminalLocation === "FGS"
                            ? FGS
                            : item.terminalLocation === "Detailed Inspection"
                            ? DetailedInspection
                            : item.terminalLocation === "NPPD"
                            ? NPPD
                            : item.terminalLocation === "Army"
                            ? Army
                            : item.terminalLocation === "Rangers"
                            ? Rangers
                            : item.terminalLocation === "FC"
                            ? FC
                            : Other
                        }
                        alt={item.terminalLocation}
                      />
                    ) : (
                      <div></div>
                    )}
                  </Grid>
                  <Grid md={11}>
                    <Typography className="subHeading">
                      <b>{item.vehicleRegNumber ? item.vehicleRegNumber : "-"}</b> at{" "}
                      <b>{item.terminalLocation ? item.terminalLocation : "-"}</b> at{" "}
                      <b>{moment(new Date(item.createdAt)).format("hh:mm A, DD/MM/YYYY ")}</b>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ))
        ) : (
          <div style={{ marginTop: "20px" }}>
            <NoRecordFound />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
